export default {
  open: (data: any) => {},
};
